import H2 from "@/atoms/text/H2";
import Para from "@/atoms/text/Para";
import Button from "@/atoms/Button";

const Discover = ({ title, content, bgColor, color, href, cta, onClick }) => {
  return (
    <section className={`pv-15-d pv-8 bc-${bgColor}`}>
      <div className="container ta-center">
        <H2
          color={color}
          className={`${content ? "mb-5" : "mb-7"} bold`}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {content && (
          <Para
            desktopSize="lg"
            mobileSize="lg"
            color="black"
            dangerouslySetInnerHTML={{ __html: content }}
            className="mb-7-d mb-5 ta-center"
          />
        )}
        <Button href={href} size="md" onClick={onClick}>
          {cta}
        </Button>
      </div>
    </section>
  );
};

Discover.defaultProps = {
  bgColor: "grad-blue",
  color: "white",
  href: "#",
  cta: "See Prices",
};
export default Discover;
